import { render, staticRenderFns } from "./PrimaryActionButton.vue?vue&type=template&id=dc55a3c2&scoped=true&"
import script from "./PrimaryActionButton.vue?vue&type=script&lang=js&"
export * from "./PrimaryActionButton.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryActionButton.vue?vue&type=style&index=0&id=dc55a3c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc55a3c2",
  null
  
)

export default component.exports